import React from 'react';
import { useNavigate } from 'react-router-dom'; // Using useNavigate for navigation
import Navbar from '../components/Navbar'; // Adjust the path as needed
import '../styles/CAD.css';

const DataAnalysis = () => {
    const navigate = useNavigate();

    // For demonstration, the Learn More buttons currently redirect to Google.
    // Replace with your actual paths or navigation logic as needed.
    const handleNavigation = () => {
        navigate('/contact'); // Use navigate instead of window.location.href
    };

    return (
        <>
            <Navbar />
            <div className="custom-app-development">
                <div className="content-box">
                    <header className="header">
                        <h1>Data Analysis</h1>
                        <p className="tagline">
                            Unlock valuable insights from your data with our expert analysis.
                        </p>
                    </header>

                    <section className="introduction">
                        <p>
                            In today's data-driven world, transforming raw data into meaningful insights is crucial for gaining a competitive edge. Our Data Analysis services help you make informed decisions by turning complex data sets into clear, actionable intelligence.
                        </p>
                    </section>

                    <section className="why-choose-us">
                        <h2>Why Choose Our Data Analysis?</h2>
                        <p>
                            We combine advanced analytical techniques with deep domain expertise to provide customized solutions that reveal hidden trends and opportunities. Our comprehensive approach ensures that you can harness the full potential of your data for strategic growth.
                        </p>
                    </section>

                    <section className="tech-stack">
                        <h2>Our Tools & Methodologies</h2>
                        <p>
                            Our analysis process integrates state-of-the-art tools and proven methodologies:
                        </p>
                        <ul>
                            <li><strong>Data Visualization:</strong> Transform data into intuitive visual stories using tools like Tableau and Power BI.</li>
                            <li><strong>Statistical Analysis:</strong> Employ rigorous statistical methods to validate insights and forecast trends.</li>
                            <li><strong>Predictive Analytics:</strong> Leverage machine learning models to anticipate future outcomes.</li>
                            <li><strong>Big Data Processing:</strong> Use scalable platforms like Apache Spark and Hadoop for handling large datasets.</li>
                        </ul>
                    </section>

                    <section className="secure-practices">
                        <h2>Secure & Compliant Analysis</h2>
                        <p>
                            We prioritize data security and privacy throughout our analysis process. Our solutions adhere to industry best practices and regulatory standards to ensure your data remains confidential and protected.
                        </p>
                    </section>

                    <section className="services">
                        <h2>Our Data Analysis Services</h2>
                        <div className="service-container">
                            <div className="service-box">
                                <h3>Data Visualization</h3>
                                <p>
                                    Convert complex datasets into clear, impactful visualizations that drive actionable insights.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/data-visualization')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Predictive Analytics</h3>
                                <p>
                                    Forecast trends and future outcomes using advanced predictive modeling techniques.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/predictive-analytics')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Business Intelligence</h3>
                                <p>
                                    Leverage comprehensive BI tools to turn raw data into strategic insights and performance metrics.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/business-intelligence')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Data Mining & Reporting</h3>
                                <p>
                                    Extract valuable information from your data through deep data mining techniques and customized reporting.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/data-mining')}>
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default DataAnalysis;
